import { defineMessages } from '@atlassian/jira-intl';

const commonMessages = defineMessages({
	title: {
		id: 'eoc-on-call.tours.get-started.welcome-modal.title-nonfinal',
		defaultMessage: 'Get started with your team’s operation',
		description: 'Title of welcome modal',
	},
	description: {
		id: 'eoc-on-call.tours.get-started.welcome-modal.description-nonfinal',
		defaultMessage:
			"Congratulations! Your team is now fully equipped to respond to critical alerts. Check out your on-call schedule to review shift assignments, explore available integrations, and customize your operations to tailor it to your team's needs.",
		description: 'Description of welcome modal',
	},
	explore: {
		id: 'eoc-on-call.tours.get-started.welcome-modal.explore',
		defaultMessage: 'I’ll explore myself',
		description: 'Action button that shows user want to explore page itself',
	},
	tour: {
		id: 'eoc-on-call.tours.get-started.welcome-modal.tour',
		defaultMessage: 'Show me how',
		description: 'Action button that starts onboarding experience',
	},
});

export default commonMessages;
